<template>
    <button v-if="canCancelTransport"
            class="red-button" @click="openReplyModal(HpoTransportStatus.TERMINATED)">
<!--        <i class="fa-solid fa-ban"></i>-->
        {{ pgettext('action', 'Terminate transport') }}
    </button>
</template>

<script>

import {HpoRole, HpoTransportStatus} from "../../../../choices";
import {patientInHospital, patientTransported} from "../utils";


export default {
    name: 'TransportTerminateButton',
    emists: ['openReplyModal'],
    props: {
        patient: {
            type: Object,
            required: true
        },
        member: {
            type: Object,
            required: true
        },
    },
    setup() {
        return {
            // Imports
            HpoRole,
            HpoTransportStatus,
            patientInHospital,
            patientTransported,
        }
    },
    computed: {
        canCancelTransport() {
            return (
                this.member.role === HpoRole.ZOS &&
                this.patientTransported(this.patient) &&
                !this.patientInHospital(this.patient)
            )
        }
    },
    methods: {
        openReplyModal(reply) {
            this.$emit('openReplyModal', reply, this.patient)
        },
    }
}

</script>
